// Place the Smoke Drive row-share menu in the viewport (portaled, not clipped by the file list)

const DEFAULT_MENU = { width: 216, height: 88 };
const DEFAULT_VIEWPORT = { width: 1280, height: 800 };

/**
 * @param {{
 *   buttonRect: { top: number, bottom: number, left: number, right: number },
 *   menuSize?: { width: number, height: number } | null,
 *   viewport?: { width: number, height: number },
 *   gap?: number,
 *   pad?: number,
 * }} args
 * @returns {{ top: number, left: number }}
 */
export function placeOperatorDriveShareMenu({
    buttonRect,
    menuSize,
    viewport,
    gap = 6,
    pad = 8,
}) {
    const menuWidth = menuSize?.width > 0 ? menuSize.width : DEFAULT_MENU.width;
    const menuHeight = menuSize?.height > 0 ? menuSize.height : DEFAULT_MENU.height;
    const vw = viewport?.width ?? DEFAULT_VIEWPORT.width;
    const vh = viewport?.height ?? DEFAULT_VIEWPORT.height;

    let left = buttonRect.right - menuWidth;
    if (left < pad) left = pad;
    if (left + menuWidth > vw - pad) {
        left = Math.max(pad, vw - pad - menuWidth);
    }

    const spaceBelow = vh - buttonRect.bottom - gap;
    const spaceAbove = buttonRect.top - gap;
    let top;
    if (spaceBelow >= menuHeight || spaceBelow >= spaceAbove) {
        top = buttonRect.bottom + gap;
        if (top + menuHeight > vh - pad) {
            top = Math.max(pad, vh - pad - menuHeight);
        }
    } else {
        top = buttonRect.top - gap - menuHeight;
        if (top < pad) top = pad;
    }

    return { top, left };
}
